// @// NOTE: expandable.ts
// riot Tagに追加 mixinされ、「続きを見る」機能を提供する
// something-tag
//   .expandable-wrap(class="{expanded: expanded}") コンテンツ要素
//   .expandable-over(class="{expanded: expanded}") 白いもや
//   .expandable-btn-wrap(class="{expanded: expanded}")
//     span.btn(onClick="{onClickExpandableBtn}")
// という３つの要素が必要で、CSSのサンプルは以下の通り。
    // :scope {
    //   display: block;
    //   position: relative;
    // }
    // .expandable-wrap {
    //   max-height: 300px;
    //   overflow: hidden;
    // }
    // .expandable-wrap.expanded {
    //   max-height: none;
    //   overflow: none;
    // }
    // .expandable-over {
    //   width: 100%;
    //   z-index: 3;
    //   bottom: 0;
    //   position: absolute;
    //   margin-bottom: -1px;
    //   height: 100px;
    //   content: '';
    //   background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%); /* FF3.6-15 */
    //   background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* Chrome10-25,Safari5.1-6 */
    //   background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    //   filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */
    // }
    // .expandable-btn-wrap {
    //   z-index: 4;
    //   position: absolute;
    //   bottom: 0;
    //   text-align: center;
    //   width: 100%;
    // }
    // .expandable-btn-wrap .btn {
    //   padding-left: 100px;
    //   padding-right: 100px;
    // }
    // .expandable-over.expanded,
    // .expandable-btn-wrap.expanded {
    //   display: none;
    // }

import { BaseTag } from "mixs/base/base_mixin";

class Expandable extends BaseTag {
  expanded: boolean = false;
  onClickExpandableBtn(){
    this.expanded = true;
    this.update();
    return false;
  }
}

riot.mixin("shared.expandable", Expandable as riot.TagMixin);
